import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';

export type DocumentFieldCorrectedAction = {
	type: 'DOCUMENT_FIELD_CORRECTED';
	payload: DocumentDetailPayload;
};

export default (payload: DocumentDetailPayload): DocumentFieldCorrectedAction => ({
	type: 'DOCUMENT_FIELD_CORRECTED',
	payload,
});
